import { isValidCodiceFiscale } from "../helpers/anagraficaHelpers"
import { fascicoloModel } from "../models";

export const isFascicoloCessato = (prestazioni = []) => {
  if (prestazioni.length === 0) return false;

  const now = new Date();
  return prestazioni.every((prestazione) => {
    const endDate = prestazione?.endDate ?? prestazione?.EndDate;
    if (endDate == null) return false;

    const parsedEndDate = new Date(endDate);
    return !Number.isNaN(parsedEndDate.getTime()) && parsedEndDate <= now;
  });
};

// Fonte unica dello stato del fascicolo: il calcolo di completezza è demandato
// al backend (action getFascicoliAndRelatedEntities), che espone `stato` come
// stringa con i motivi di incompletezza (vuota quando il fascicolo è completo).
// Il frontend NON ricalcola più lo stato: qui accentriamo la sola lettura/mappatura.
export const mapFascicoloStatoFromBE = (fascicolo) => {
  const reasons = fascicolo?.stato ?? "";
  const isCompleted = !reasons || reasons.length === 0;
  return { isCompleted, reasons };
};

export const FascicoloHelpers = () => {

  const GetClienteType = (anagrafica) => {
    if (!anagrafica) return "";

    let toReturn = "";
    if (anagrafica.isPg) {
        toReturn = "Persona Giuridica";
        if (isValidCodiceFiscale(anagrafica.codiceFiscale)) {
        toReturn = "Ditta Individuale";
        }
    } else {
        toReturn = "Persona Fisica";
    }
    return toReturn;
  };
  const GetFascicoliAttivi = (fascicoli) => {
    let allFascCessatiIds = fascicoli.filter(
          (fascicolo) =>
            fascicolo.prestaziones.length > 0 &&
            fascicolo.prestaziones.filter(
              (prestazione) =>
                prestazione.EndDate !== null &&
                new Date(prestazione.EndDate) < new Date()
            ).length === fascicolo.prestaziones.length
        ).map((fascicolo) => fascicolo.Id);

    return fascicoli.filter((fascicolo) => !allFascCessatiIds.includes(fascicolo.Id));
  }
  const GetAnagraficheDocInScadenzaFromFrascicoli = (fascicoli) => {
    let anagDocInScadArr = [];
    const dtTo = new Date(new Date().setMonth(new Date().getMonth() + 1));
    let allAnagInScad = fascicoli.flatMap((fascicolo) =>
      fascicolo.anagrafica_fascicolos.map((item) => {
        return {
          anagrafica: item.anagrafica,
          fascicolo: fascicolo,
        };
      })
      ).filter(
        (x) =>
          x.anagrafica.DocScad !== null &&
          x.anagrafica.DocScad !== undefined &&
          x.anagrafica.DocScad !== ""
        );

    for (let i = 0; i < allAnagInScad.length; i++) {
      const anagrafica_fascicolo = allAnagInScad[i];
      const dtDocScad = anagrafica_fascicolo.anagrafica.DocScad ?? null;
      let fascicoloId = anagrafica_fascicolo.fascicolo.Id;
      let fascicoloName = anagrafica_fascicolo.fascicolo.Name;
      let isScaduto = new Date(dtDocScad).setHours(0, 0, 0, 0) <= new Date(dtTo).setHours(0, 0, 0, 0);
      if (isScaduto && anagDocInScadArr.filter((x) => x.id === anagrafica_fascicolo.anagrafica.Id).length === 0) {
        const itemModel = {
          id: anagrafica_fascicolo.anagrafica.Id,
          fascicoloId: fascicoloId,
          fascicoloName: fascicoloName,
          denominazione: anagrafica_fascicolo.anagrafica.Denominazione,
          date: dtDocScad,
          scaduto: isScaduto,
        };
        anagDocInScadArr.push(itemModel);
      }
    }

    return anagDocInScadArr;
  }
  const GetCopmleteAndIncompleteFascicoliModel = (fascicoli,tenantId,aziendaId) => {
    let fascicoliComplete = [];
    let fascicoliIncomplete = [];
    for (let i = 0; i < fascicoli.length; i++) {
      const fascicolo = fascicoli[i];
      const { isCompleted, reasons } = mapFascicoloStatoFromBE(fascicolo);
      const itemModel = new fascicoloModel(
        fascicolo.id,
        tenantId,
        aziendaId,
        fascicolo.name,
        fascicolo.date,
        fascicolo.isPrivate,
        fascicolo.createdOn,
        fascicolo.modifiedOn,
        [],
        isCompleted,
        reasons,
        fascicolo.createdBy,
        fascicolo.modifiedBy,
      );
      if (itemModel.status) {
        fascicoliComplete.push(itemModel);
      } else {
        fascicoliIncomplete.push(itemModel);
      }
    }
    let topItems = fascicoliIncomplete.filter((fascicolo) =>
      fascicolo.statusReasons.includes("Cliente non presente")
    );
    let bottomItems = fascicoliIncomplete.filter(
      (fascicolo) =>
        !fascicolo.statusReasons.includes("Cliente non presente")
    );
    let newArray = topItems.concat(bottomItems);

    return {
      fascicoliComplete: fascicoliComplete,
      fascicoliIncomplete: newArray,
    };
  }
  const EncodeBase64 = async (file) => {
    let fileBase64 = [];
    var reader = new FileReader();
    reader.readAsDataURL(file);

    return new Promise((resolve) => {
      reader.onload = async () => {
        var base64 = reader.result;

        fileBase64.push({ name: file.name, type: file.type, encrypt: base64 });
        resolve(fileBase64);
      };
    });
  }

  return {
    GetClienteType,
    GetFascicoliAttivi,
    GetAnagraficheDocInScadenzaFromFrascicoli,
    GetCopmleteAndIncompleteFascicoliModel,
    EncodeBase64
  };
};
